import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ApplicationUIContext } from '../Provider/Provider';

const StyledTableContainer = styled.div`
  margin-bottom: 16px;

  table {
    border-spacing: 0;
    border: 1px solid #f0f0f0;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    td {
      border-bottom: 1px solid #f0f0f0;
      border-right: 1px solid #f0f0f0;

      :last-child {
        border-right: 0;
      }
    }
  }
`;

const StyledTable = styled.table`
  width: 100%;
  ${({ isMobile }) => isMobile && 'font-size: 16px;'}
`;

const StyledHeader = styled.td`
  width: 35%;
  padding: 8px 16px;
  background-color: #f5f5f5;
`;

const StyledValue = styled.td`
  width: 65%;
  padding: 8px 16px;
`;

const SummaryGrid = ({ values }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <StyledTableContainer>
      <StyledTable isMobile={isMobile}>
        <tbody>
          {values.map((value, index) => (
            <tr key={`${value}.${index}`}>
              <StyledHeader>{value[0]}</StyledHeader>
              <StyledValue>{value[1]}</StyledValue>
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </StyledTableContainer>
  );
};

SummaryGrid.propTypes = {
  values: PropTypes.array,
};

export { SummaryGrid };
